import { devices } from '@helpers/utils.js';

const BackgroundTypeBackgroundColorSave = ({
  backgroundColorOptions,
  blockId,
  defaultBlockCssClass,
  printBackgroundStyles,
}) => {
  return (
    <style>
      {devices.map((device) => {
        const deviceType = device.type;
        const backgroundColorSettings =
          backgroundColorOptions[deviceType].settings;
        const backgroundColor = backgroundColorSettings.backgroundColor
          ? backgroundColorSettings.backgroundColor
          : '';

        let cssCode = '';
        const printQuery = printBackgroundStyles
          ? `, print and (max-width: ${backgroundColorOptions[deviceType].breakpoint}px)`
          : ``;

        if (backgroundColor) {
          cssCode = `@media only screen and (max-width: ${backgroundColorOptions[deviceType].breakpoint}px)${printQuery} {
									.${defaultBlockCssClass}.${defaultBlockCssClass}-${blockId} { 
										background-color: ${backgroundColor}; 
									}
								}`;
        }

        return cssCode;
      })}
    </style>
  );
};

export default BackgroundTypeBackgroundColorSave;
